import { render, staticRenderFns } from "./AutomationStatisticsGeneral.vue?vue&type=template&id=56b28713&scoped=true&"
import script from "./AutomationStatisticsGeneral.vue?vue&type=script&lang=js&"
export * from "./AutomationStatisticsGeneral.vue?vue&type=script&lang=js&"
import style0 from "./AutomationStatisticsGeneral.vue?vue&type=style&index=0&id=56b28713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b28713",
  null
  
)

export default component.exports